import AddClassroom from './AddClassroom';

export default AddClassroom;
